import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';

const PageBody = ({ aboutMe, loading, error }) => {
  const { t } = useTranslation();
  const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || "http://localhost:1337";
  const { ref: inViewRef } = useInView({ triggerOnce: true, threshold: 0.1 });

  const renderContent = (content) => {
    return content.map((block, index) => {
      if (block.type === 'paragraph') {
        return (
          <div className="col-12" key={index}>
            <p className="lead display-6 text-dark mb-0 mt-0" style={{ paddingTop: "0px", paddingBottom: "0px" }}>
              {block.children.map((child, i) => (
                <span key={i}>{child.text}</span>
              ))}
            </p>
          </div>
        );
      }

      if (block.type === 'list' && block.format === 'ordered') {
        return (
          <div className="col-12" key={index}>
            <ol className="lead display-6 text-dark">
              {block.children.map((item, i) => (
                <li key={i} className="lead display-6 text-dark">
                  {item.children.map((child, j) => (
                    <span key={j}>{child.text}</span>
                  ))}
                </li>
              ))}
            </ol>
          </div>
        );
      }

      return null;
    });
  };

  return (
    <section onContextMenu={(e) => e.preventDefault()}>
      <div className="container mt-10">
        <div className="row g-3 g-xl-5" ref={inViewRef}>
          
          {/* Image */}
          {aboutMe?.photo?.url && (
            <div className="col-12">
              <div className="media media-image equal-2-1" onContextMenu={(e) => e.preventDefault()}>
                <img
                  src={`${STRAPI_URL}${aboutMe.photo.formats?.large?.url || aboutMe.photo.formats?.medium?.url || aboutMe.photo.url}`}
                  alt={aboutMe.photo.alternativeText || "Alberto Lussana"}
                  className="col-12"
                  style={{ display: "block" }}
                />
              </div>
            </div>
          )}

          {/* Loading */}
          {loading && (
            <div className="col-12">
              <p>{t('global.loading', 'Caricamento...')}</p>
            </div>
          )}

          {/* Error */}
          {error && (
            <div className="col-12">
              <p className="text-danger">
                {t('global.error', 'Errore')}: {error}
              </p>
            </div>
          )}

          {/* Content */}
          {!loading && !error && aboutMe?.body && renderContent(aboutMe.body)}

        </div>
      </div>
    </section>
  );
};

export default PageBody;

